import { render, staticRenderFns } from "./modalTransportistas.vue?vue&type=template&id=52c8d2b2&scoped=true&"
import script from "./modalTransportistas.vue?vue&type=script&lang=js&"
export * from "./modalTransportistas.vue?vue&type=script&lang=js&"
import style0 from "./modalTransportistas.vue?vue&type=style&index=0&id=52c8d2b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c8d2b2",
  null
  
)

export default component.exports